const PREDICT_BASE = (() => {
  if (typeof window !== 'undefined' && window.location) {
    const { hostname, protocol } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:5000';
    }
    return `${protocol}//${hostname}/app`;
  }
  return process.env.REACT_APP_PREDICT_URL || 'http://localhost:5000';
})();

export function getPredictBaseUrl() {
  return PREDICT_BASE;
}

export function getPredictEndpoint() {
  return `${PREDICT_BASE}/predict`;
}

export default PREDICT_BASE;
